import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestLicenseClientUuidDelete = {
    path: "/plugin-update/:slug/license/:blogId/client-uuid",
    method: RouteHttpVerb.DELETE
};
export { locationRestLicenseClientUuidDelete };
